import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import ETVPopup from './ETVPopup';

const TYPES = {
  success:{severity:'success',label:'Success',icon:<CheckCircleOutlineIcon/>,color:'success.main'},
  failure:{severity:'error',label:'Failure',icon:<ErrorOutlineIcon/>,color:'error.main'},
  error:{severity:'error',label:'Failure',icon:<ErrorOutlineIcon/>,color:'error.main'},
  info:{severity:'info',label:'Information',icon:<InfoOutlinedIcon/>,color:'info.main'},
  progress:{severity:'info',label:'In progress',icon:<HourglassTopIcon/>,color:'primary.main'},
};

export default function ETVMessagePopup({
  open,
  onClose,
  type='info',
  title,
  message,
  details,
  actions,
  closeLabel='Close',
  allowClose,
}) {
  const tone=TYPES[type] || TYPES.info;
  const isProgress=type==='progress';
  const canClose=allowClose !== undefined ? allowClose : !isProgress;
  const footer=actions || (canClose ? <Button onClick={onClose}>{closeLabel}</Button> : null);

  return <ETVPopup open={open} onClose={canClose?onClose:undefined} width="small"
    icon={tone.icon} title={title || tone.label} description={tone.label}
    loading={isProgress} closeButton={canClose} bottomActions={footer}>
    <Stack spacing={2}>
      <Alert severity={tone.severity} icon={false} sx={{borderRadius:2.5}}>
        <Typography variant="body1" sx={{whiteSpace:'pre-wrap',lineHeight:1.6}}>{message}</Typography>
      </Alert>
      {details && <Typography variant="body2" color="text.secondary" sx={{whiteSpace:'pre-wrap'}}>{details}</Typography>}
      {isProgress && <Box sx={{display:'flex',alignItems:'center',gap:1.5,p:1.5,borderRadius:2,bgcolor:'action.hover'}}>
        <Typography variant="body2" fontWeight={600}>Please wait…</Typography>
      </Box>}
    </Stack>
  </ETVPopup>;
}
